import { PermissionsScope } from '../../policies/policy.model'

export const EXECUTION_FRAGMENT = 'execution'
export const EXECUTION_SCOPE: PermissionsScope = 'activities'
